//Global variables accessed within TypeScript
/* eslint-disable */
declare var popupEnabled: boolean;
declare var autoAdvanceNext: boolean;
declare var allowNextButton: boolean;
declare var allowPreviousButton: boolean;
declare var subtitles: boolean;
declare var mediaType: string;
declare var cdnSubfolder: string;
declare var languageFolder: string;
declare var mediaFile: string;

//Legacy Support: Bridge function from static content to media class
function SetupMedia() { /* do nothing - page load handles this */ }

/* eslint-disable-next-line */
var aptMedia: any = aptMedia || {};
aptMedia = (function ($: JQueryStatic) {
	const _storage: Storage = window.sessionStorage || null;
	const _storageAvailable: boolean = _checkStorage();
	let _eventLoggerUrl: string;
	const _cdn = "//media.aptmetrics.com/";
	//const _cdn = "//d2b7hf8ssvh3zu.cloudfront.net/"; /* Legacy CDN */
	//const _cdn = "//d373xyg0sh0pku.cloudfront.net/"; /* Alternate CDN */
	let _player: HTMLVideoElement;
	let _audio: HTMLAudioElement;
	const _mediaLoadStartTime: Date = new Date();
	let _mediaStartPlayTime: Date;
	//const _prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	/** Initialize media */
	function _init() {
		if ($("#video").length > 0) _initVideo();
		else if ($("#audio").length > 0) _initAudio();

		//if (_prefersReducedMotion) {  // prevent background video from playing/looping
		//	document.querySelectorAll("video").forEach((el, idx) => { let e = el as HTMLMediaElement; e.pause() })
		//}
	}

	function _initVideo() {
		_setBottomNavButtons();

		let url: string = _cdn;
		if (cdnSubfolder !== "") url = url + cdnSubfolder + '/';
		url = url + 'multimedia/' + languageFolder;
		const mediaFolder: string = url + mediaType + '/';
		const langCode: string = languageFolder.substring(0, 2);

		if (mediaType === "video") {
			$("#track, #source").remove();
			_player = document.getElementById("video") as HTMLVideoElement;
			_player.crossOrigin = "anonymous"; // Text files cause CORS issues, even though .mp4 loads properly
			_player.preload = "metadata";
			_player.src = mediaFolder + mediaFile + ".mp4";

			if (subtitles) {
				let subtitleEnabled = "";

				if (_storageAvailable) {
					subtitleEnabled = _storage.getItem("subtitleEnabled") === "showing" ? "default" : "";
					_storage.setItem("subtitleEnabled", subtitleEnabled);
				}

				try {
					$(_player).append("<track kind='subtitles' crossOrigin='anonymous' " + subtitleEnabled + " srclang='" + langCode +
						"' src='" + mediaFolder + mediaFile + ".vtt' label='English' id='track' />");

					_player.textTracks.addEventListener("change", (e: Event) => {
						const trackList = e.target as TextTrackList;
						_logMediaStatus("Subtitle status: " + trackList[0].mode + " | Subtitle file: " + mediaFile + ".vtt");
						console.info("Subtitle status: " + trackList[0].mode + " | Subtitle file: " + mediaFile + ".vtt");
						_storage.setItem("subtitleEnabled", trackList[0].mode);
					});
				}
				catch (ex: any) {
					_logMediaStatus("TextTrack error: " + ex.message);
					console.error("TextTrack error: " + ex.message);
				}
			}
		}

		_player.load();

		_eventLoggerUrl = siteUrl.concat("/ClientLogging/LogEventPSSWebID");
		_addMediaListeners();
		_player.addEventListener("ended", _onComplete);

		_player.addEventListener("loadeddata", () => {	// If playback issues continue, use "canplaythrough"
			if (_player.readyState >= 2) {					// If playback issues continue, use 3 (HAVE_FUTURE_DATA)
				const playPromise = _player.play();

				if (playPromise !== undefined) {
					playPromise
						.then(_ => { /* Automatic playback started! */ })
						.catch(error => {
							console.log("Auto-play was prevented: " + error.message);
						});
				}
			}
		});
	}

	let audioAdvance = false;
	function _initAudio() {
		_audio = document.getElementById("audio") as HTMLAudioElement;
		let advance = $(_audio).data("advance");
		audioAdvance = advance === undefined ? false : advance;
		
		if (audioAdvance) {
			_audio.classList.add("fixed-bottom", "mx-auto", "mb-2");
			_audio.controls = true;
			_audio.setAttribute("controlsList", "nodownload");
			_audio.addEventListener("ended", _onComplete);
		}

		if ($("audio").prop("autoplay")) { _audio.play(); }
 	}

	const _setBottomNavButtons = function () {
		$('#navBottom').appendTo($('#bottomNavPlaceholder'))
		if (!allowNextButton) $("#next").css("display", "none !important").css("opacity", "0");
		if (!allowPreviousButton) $("#previous").css("display", "none !important").css("opacity", "0");
	}

	const _onComplete = function () {
		if (audioAdvance || autoAdvanceNext) { $("#next").trigger("click"); }
		else { $("#next").fadeIn().fadeTo(500, 1); }
	}

	const _addMediaListeners = function () {
		if (_player !== null) {
			// Available video element events listed at https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement#events
			_player.addEventListener("error", function (this: HTMLVideoElement, e: Event) { _getMediaStatus(this, "Media Error"); _reloadMedia(); });
			_player.addEventListener("stalled", function (this: HTMLVideoElement, e: Event) { _getMediaStatus(this, "Media Stalled"); _reloadMedia(); });
		}
	}

	function _reloadMedia() {
		$("#reloadMedia").show();
	}

	const _getMediaStatus = function (mediaObj: HTMLVideoElement, eventName: string) {
		const curTime: Date = new Date();
		let msg = "<MediaEventName>" + eventName + "</MediaEventName>\n";
		msg = msg.concat("<MediaEventLocalTime>", curTime.toLocaleTimeString('en-US').replace(/\u200E/g, ''), "</MediaEventLocalTime>\n");
		if (mediaObj !== null) {
			let ElapsedTimeSincePlay = 0;
			if (_mediaStartPlayTime !== undefined) ElapsedTimeSincePlay = (curTime.getTime() - _mediaStartPlayTime.getTime()) / 1000;
			const ElapsedTimeSinceLoad = (curTime.getTime() - _mediaLoadStartTime.getTime()) / 1000;
			msg = msg.concat("<MediaCurrentSrc>", mediaObj.currentSrc, "</MediaCurrentSrc>\n");
			msg = msg.concat("<MediaDuration>", mediaObj.duration.toFixed(2), "</MediaDuration>\n");
			msg = msg.concat("<MediaCurrentTime>", mediaObj.currentTime.toFixed(2), "</MediaCurrentTime>\n");
			msg = msg.concat("<ElapsedTimeSincePlay>", ElapsedTimeSincePlay.toFixed(2), "</ElapsedTimeSincePlay>\n");
			msg = msg.concat("<ElapsedTimeSinceLoad>", ElapsedTimeSinceLoad.toFixed(2), "</ElapsedTimeSinceLoad>\n");
			let mNetworkState = "";

			switch (mediaObj.networkState) {
				case 0: mNetworkState = "NETWORK_EMPTY"; break;			//The mediaObj has not yet been initialized. All attributes are in their initial states.
				case 1: mNetworkState = "NETWORK_IDLE"; break;			//The mediaObj's resource selection algorithm is active and has selected a resource, but it is not actually using the network at this time.
				case 2: mNetworkState = "NETWORK_LOADING"; break;		//The user agent is actively trying to download data.
				case 3: mNetworkState = "NETWORK_NO_SOURCE"; break;	//The mediaObj's resource selection algorithm is active, but it has not yet found a resource to use.
			}
			msg = msg.concat("<NetworkState>", mNetworkState, "</NetworkState>\n");

			let mReadyState = "";
			switch (mediaObj.readyState) {
				case 0: mReadyState = "HAVE_NOTHING"; break;			 //No information whether or not the media is ready
				case 1: mReadyState = "HAVE_METADATA"; break;		 //Metadata for the media is ready
				case 2: mReadyState = "HAVE_CURRENT_DATA"; break;	 //Data for the current playback position is available, but not enough data to play next frame/millisecond
				case 3: mReadyState = "HAVE_FUTURE_DATA"; break;	 //Data for the current and at least the next frame is available
				case 4: mReadyState = "HAVE_ENOUGH_DATA"; break;	 //Enough data available to start playing
			}
			msg = msg.concat("<MediaReadyState>", mReadyState, "</MediaReadyState>\n");

			let mErrMsg = ""
			if (mediaObj.error !== null && mediaObj.error !== undefined) {
				switch (mediaObj.error.code) {
					case 1: mErrMsg = "MEDIA_ERR_ABORTED"; break;
					case 2: mErrMsg = "MEDIA_ERR_NETWORK"; break;
					case 3: mErrMsg = "MEDIA_ERR_DECODE"; break;
					case 4: mErrMsg = "MEDIA_ERR_SRC_NOT_SUPPORTED"; break;
				}
			}
			msg = msg.concat("<MediaErrorCode>", mErrMsg, "</MediaErrorCode>\n");

			console.log(msg);
			_logMediaStatus(msg);
		}
	}

	const _logMediaStatus = function (message: string) {
		const log = message
			+ "<url>" + encodeURIComponent(document.location.toString()) + "</url>"
			+ "<readystate>" + document.readyState + "</readystate>";
		aptAjax.request({
			url: _eventLoggerUrl,
			data: { msg: log, webid: apt.sm.webId }
		}).fail((xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
			console.log(errorThrown);
		});
	}

	function _checkStorage(): boolean {
		try {
			const x = "__storage_test__";
			_storage.setItem(x, x);
			_storage.removeItem(x);
			return true;
		}
		catch {
			return false;
		}
	}

	return {
		init: _init,
		reloadMedia: _reloadMedia
	}
})($);